import apiClient from './apiClient'

// GET /role-min-purchases/ — lista de roles activos con su mínimo de compra
// (id, slug, label, is_wholesale, min_purchase_amount).
export const getRoleMinPurchases = async (params = {}) => {
  const response = await apiClient.get('/role-min-purchases/', { params })
  return response.data
}

// PATCH /role-min-purchases/:id/ — UPSERT del mínimo por rol.
export const updateRoleMinPurchase = async (id, minPurchaseAmount) => {
  const response = await apiClient.patch(`/role-min-purchases/${id}/`, {
    min_purchase_amount: minPurchaseAmount,
  })
  return response.data
}
